// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_X6A","cls2":"LoggedOutDiscoveryPage-cls2_wMN LoggedOutDiscoveryPage-cls1_X6A"};